/* eslint-disable @typescript-eslint/no-explicit-any */

import { combineReducers, createAction } from '@reduxjs/toolkit'
import account from './features/account'
import accountComposition from './features/accountComposition'
import auth from './features/auth'
import ballots from './features/ballots'
import breakdown from './features/breakdown'
import config from './features/config'
import featuredVotes from './features/featuredVotes'
import fundBreakdowns from './features/fundBreakdowns'
import fundFilter from './features/fundFilter'
import generalMeetings from './features/generalMeetings'
import investor from './features/investor'
import investorVotes from './features/investorVotes'
import notifications from './features/notifications'
import organizationPolls from './features/organizationPolls'
import organizations from './features/organizations'
import polls from './features/polls'
import searchFilters from './features/searchFilters'
import singleBallot from './features/singleBallot'
import statistics from './features/statistics'
import topOrganizations from './features/topOrganizations'
import userPreferences from './features/userPreferences'
import voteResults from './features/voteResults'
import votingPolicies from './features/votingPolicies'

const appReducer = combineReducers({
  account,
  breakdown,
  ballots,
  singleBallot,
  generalMeetings,
  organizations,
  polls,
  investor,
  investorVotes,
  accountComposition,
  searchFilters,
  config,
  notifications,
  userPreferences,
  fundFilter,
  fundBreakdowns,
  featuredVotes,
  statistics,
  topOrganizations,
  auth,
  votingPolicies,
  voteResults,
  organizationPolls,
})

export const logOutAction = createAction('auth/logOut')

const rootReducer = (state: any, action: any) => {
  if (action.type === logOutAction.type) {
    state = { config: state.config } // only keep the things we want to pass through
  }

  return appReducer(state, action)
}

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
